import React from "react";

function IconMapMarker(data) {
    return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={data.w}
          height={data.h}
          viewBox="0 0 68 100"
        >
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fillRule="nonzero" transform="translate(-16)">
              <g transform="translate(16)">
                <path
                  fill="#DFA370"
                  d="M0 99.9533302L0 94.2596158 65.7638883 94.2596158 65.7638883 100z"
                ></path>
                <path
                  fill="#3D3833"
                  d="M34.377 86l-1.822-1.074c-.794-.56-18.963-14.375-24.661-24.315C-1.962 46.05-2.99 21.968 11.023 9.367A32.149 32.149 0 0135.17.033a33.97 33.97 0 0122.372 9.334c14.013 12.368 12.892 36.45 2.85 51.057-5.512 9.754-23.821 23.568-24.568 24.128L34.377 86zM33.349 5.586a27.615 27.615 0 00-18.356 7.654c-10.93 9.707-11.91 30.195-2.382 44.15 4.297 7.56 17.095 18.2 21.766 21.608 4.67-3.594 17.375-14.001 21.532-21.329 9.715-14 8.687-34.675-2.009-44.15a29.25 29.25 0 00-18.683-7.793l-1.868-.14z"
                ></path>
                <ellipse
                  cx="34.47"
                  cy="37.182"
                  fill="#DFA370"
                  rx="10.883"
                  ry="10.874"
                ></ellipse>
              </g>
            </g>
          </g>
        </svg>
    );
  }

export default IconMapMarker;
